import styled from "styled-components";
import { TOP_NAV_HEIGHT } from "../../constants";

export const StyledTopNav = styled.div`
  height: ${TOP_NAV_HEIGHT};
  box-shadow: 4px 0 4px 0 rgba(33, 37, 48, 0.1);
  position: fixed;
  width: 100%;
  z-index: 4;
`;

export const Gradient = styled.div`
  height: 2px;
  background-image: linear-gradient(to right, #fa5a62, #574d9e);
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 0px 70px;
  font-weight: 500;
  width: calc(100% - 381px);
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-family: HelveticaNeue-Bold;
  font-size: 20px;
  letter-spacing: -0.42px;
`;

export const SubTitle = styled.div`
  font-family: HelveticaNeue-Medium;
  font-size: 12px;
  letter-spacing: -0.2px;
`;
